import { createContext } from 'react';

const DEFAULT_VALUES = {
};

export const KnowledgeBaseContext = createContext(DEFAULT_VALUES);
